import React, { useEffect } from 'react';
import { useBlockchainProvider } from '../Blockchain/blockchainProvider';
import { ethers } from 'ethers';
import useUser, { emptyUser, IUser } from '../User/useUser';
import { IParent } from '../../components/common/types';

/** @TODO: Hanging */
export interface IUserProvider {
	data: IUser;
	fetch: (id?: string) => void;
	isLoading: boolean;
}

interface IProvider extends Omit<IUserProvider, 'fetch'> {}

export const emptyContext: IProvider = {
	data: emptyUser,
	isLoading: true,
};

export const WalletAccountProvider = ({ children }: IParent) => {
	const { isLoading, data, fetch } = useUser();
	const { account } = useBlockchainProvider();

	useEffect(() => {
		if (account === ethers.constants.AddressZero) {
			return;
		}

		fetch(account);
	}, [account]);

	return (
		<Context.Provider
			value={{
				data,
				isLoading,
			}}
		>
			{children}
		</Context.Provider>
	);
};

const Context = React.createContext<IProvider>(emptyContext);

export const useWalletAccountProvider = () => {
	return React.useContext(Context);
};
